"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Initializer = void 0;
var dom_1 = require("./dom");
var Initializer = (function () {
    function Initializer() {
        this.blocks = [];
        this.currentPage = null;
        window.Initializer = this;
    }
    Initializer.getInstance = function () {
        return this.instance || (this.instance = new this());
    };
    Initializer.initPage = function (selector, page) {
        this.getInstance().initPage(selector, page);
    };
    Initializer.prototype.initPage = function (selector, page) {
        var rootElement = document.querySelector(selector);
        if (!rootElement) {
            return;
        }
        var newPage = new page(selector, rootElement);
        this.currentPage = newPage;
    };
    Initializer.initBlock = function (selector, block) {
        this.getInstance().initBlock(selector, block);
    };
    Initializer.prototype.initBlock = function (selector, block) {
        var _this = this;
        (0, dom_1.queryAndIterateElements)(selector, function (rootElement, index, elemList) {
            var newBlock = new block(selector, rootElement, index, elemList);
            _this.blocks.push(newBlock);
            newBlock.init(rootElement);
        });
    };
    return Initializer;
}());
exports.Initializer = Initializer;
